import Vue from "vue";

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// install router module
import VueRouter from "vue-router";
Vue.use(VueRouter);
import App from "./App.vue";
import { fetchVideoAndNoteList } from "./components/getVideoAndNoteData.js";

import router from "./router";

Vue.config.productionTip = false;
// export const bus = new Vue();

new Vue({
  router,
  render: (h) => h(App),
  created() {
    fetchVideoAndNoteList().then((dataList) => {
      this.dataList = dataList;
    });
  },
  data: {
    dataList: [],
    url: "https://bibdorm.bsb-muenchen.de/BV042012027",
  },
}).$mount("#app");
